'use client';

import { useState } from 'react';

import Image from 'next/image';

import styles from './ReviewBody.module.css';

interface ReviewImageProps {
  src: string;
  alt: string;
}

const ReviewImage = ({ src, alt }: ReviewImageProps) => {
  const [errored, setErrored] = useState(false);

  if (errored) {
    return <div className={styles.imgPlaceholder} aria-hidden />;
  }

  return (
    <Image
      src={src}
      alt={alt}
      fill
      sizes="(min-width: 1024px) 50vw, 100vw"
      onError={() => setErrored(true)}
    />
  );
};

export default ReviewImage;
